import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import '../Style/Header.css'
import {Nav} from 'react-bootstrap'

const  DropDownMenu = ({pathname, setMenu, setDropDown}) => {

  return (
    <div className='custom-dropdown d-flex flex-column text-black bg-white shadow' style={{ display : 'none', }}>
      
      <Nav.Item className="nav_item" >
        <Nav.Link onClick={()=> {
            setDropDown(false)
            setMenu(false)
          }} 
            className={`navitem ${pathname === '/academy' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/academy'>
              Academy
        </Nav.Link>
      </Nav.Item>
      <Nav.Item className="nav_item" >
        <Nav.Link onClick={()=> {
            setDropDown(false)
            setMenu(false)
          }} 
            className={`navitem ${pathname === '/careerinpoland' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/careerinpoland'>
              Study Abroad
        </Nav.Link>
      </Nav.Item>

      <Nav.Item className="nav_item" >
        <Nav.Link onClick={()=> {
            setDropDown(false)
            setMenu(false)
          }} 
            className={`navitem ${pathname === '/recruitment' ? 'activeLink' : ''}`} eventKey='1' as={Link} to='/recruitment'>
              Recruitment
        </Nav.Link>
      </Nav.Item>


    </div>
  )
}

export default DropDownMenu;
